import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getALLblog } from '../services/blogService';
import ImageWithSkeleton from './ImageWithSkeleton';

export default function BlogSection() {
  const [blogPosts, setBlogPosts] = useState([]);

  const stripHtml = (html) => {
    if (!html) return "";
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString("en-GB").replace(/\//g, "-");
  };

  useEffect(() => {
    const fetchBlogPosts = async () => {
      const res = await getALLblog(); 
      console.log({res});
       
      setBlogPosts(res?.data?.data|| []);
    };
    fetchBlogPosts();
  }, []);

  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="section-title text-center mb-10">
          <p>Our recent articles about Organic</p>
          <h2>Our Blog Posts</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {blogPosts.map(post => (
            <article key={post.id} className="bg-white border border-border-color hover:shadow-md transition-shadow group">
              <div className="overflow-hidden">
                <Link to={`/blog-details/${post.blog_id}`}>
                  <ImageWithSkeleton
                    src={post.image}
                    alt={post.title}
                    containerClassName="w-full h-44"
                    className="w-full h-44 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </Link>
              </div>
              <div className="p-4">
                <p className="text-xs text-gray-400 mb-2">
                  {formatDate(post.created_at)} | <Link to="/blog" className="text-primary hover:underline">{post.cat}</Link>
                </p>
                <h4 className="text-sm font-semibold text-dark leading-snug mb-2 line-clamp-2">
                  <Link to={`/blog-details/${post.blog_id}`}className="hover:text-primary transition-colors">{post.title}</Link>
                </h4>
                <p className="text-xs text-gray-500 leading-relaxed mb-3 line-clamp-1">
                  {stripHtml(post.description)}
                </p>
                <Link to={`/blog-details/${post.blog_id}`} className="text-xs font-semibold text-primary uppercase tracking-wider hover:underline">
                  Show more
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
